import {
  carteraDashboardAssetsResponse,
  carteraDashboardGroupsResponse,
  type CarteraDashboardAssetsResponse,
  type CarteraDashboardGroupsQuery,
  type CarteraDashboardAssetsQuery,
  type CarteraDashboardGroupsResponse,
} from "@bitacorapro/api-types";
import { request } from "../client";

function qs(params: Record<string, string | number | undefined>): string {
  const entries = Object.entries(params).filter(([, v]) => v !== undefined);
  if (entries.length === 0) return "";
  return `?${new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString()}`;
}

// Ingress parse (ADR-0021/D6), same posture as getFacilityDashboard /
// getPostventaObservations — catches wire-skew between a cached
// dashboard bundle and a newer core-api deploy.
export const carteraDashboardApi = {
  groups: async (
    query: CarteraDashboardGroupsQuery = {}
  ): Promise<CarteraDashboardGroupsResponse> => {
    const json = await request<unknown>("GET", "core", `/cartera-dashboard/groups${qs(query)}`);
    return carteraDashboardGroupsResponse.parse(json);
  },
  assets: async (
    groupId: string,
    query: CarteraDashboardAssetsQuery = {}
  ): Promise<CarteraDashboardAssetsResponse> => {
    const json = await request<unknown>(
      "GET",
      "core",
      `/cartera-dashboard/groups/${groupId}/assets${qs(query)}`
    );
    return carteraDashboardAssetsResponse.parse(json);
  },
};
